import React from "react";
import { BundleOpportuntiyDetailsWrapper } from "./BundleOpportunityDetailsStyled";
import { Box } from "@mui/material";

import Opportunity from "../../images/opportunity.svg";
import New from "../../images/new.svg";
import account from "../../images/allstatusinputIcon.svg";
import { BundleOpportunityDetailsConstants } from "./Content";

const BundleOpportunityDetails = ({ opportunityDetails }) => {
  return (
    <BundleOpportuntiyDetailsWrapper className="customerStatus">
      <Box className="d-flex">
        <div className="customerDetails">
          <div className="imgIcon">
            <img src={Opportunity} alt="img" />
          </div>
          <div className="contentUser">
            <h4 className="h4padding">
              {BundleOpportunityDetailsConstants.OPPORTUNITYNAME}
            </h4>
            <p className={`para0`}>{opportunityDetails?.oppurtunityName}</p>
          </div>
        </div>

        <div className="customerDetails">
          <div className="imgIcon">
            <img src={Opportunity} alt="img" />
          </div>
          <div className="contentUser">
            <h4 className="h4padding">
              {BundleOpportunityDetailsConstants.OPPORTUNITYID}
            </h4>
            <p className={`para0`}>{opportunityDetails?.oppurtunity}</p>
          </div>
        </div>

        <div className="customerDetails">
          <div className="imgIcon">
            <img src={Opportunity} alt="img" />
          </div>
          <div className="contentUser">
            <h4 className="h4padding">
              {BundleOpportunityDetailsConstants.OPPORTUNITYTYPE}
            </h4>
            <p className={`para0`}>{opportunityDetails?.oppurtunityType}</p>
          </div>
        </div>

        <div className="customerDetails">
          <div className="imgIcon">
            <img src={account} alt="img" />
          </div>
          <div className="contentUser">
            <h4 className="h4padding">
              {BundleOpportunityDetailsConstants.ACSUBTYPE}
            </h4>
            <p className={`para0`}>{opportunityDetails?.accountSubType}</p>
          </div>
        </div>

        <div className="customerDetails">
          <div className="imgIcon">
            <img src={New} alt="img" />
          </div>
          <div className="contentUser">
            <h4 className="h4padding">
              {BundleOpportunityDetailsConstants.ACCOUNTMANAGER}
            </h4>
            <p className={`para0`}>{opportunityDetails?.accountOwner}</p>
          </div>
        </div>
        <div className="customerDetails">
          <div className="imgIcon">
            <img src={account} alt="img" />
          </div>
          <div className="contentUser">
            <h4 className="h4padding">
              {BundleOpportunityDetailsConstants.PARTNERRESELLER}
            </h4>
            <p className={`para0`}>{opportunityDetails?.memberOf}</p>
          </div>
        </div>

        <div className="customerDetails">
          <div className="imgIcon">
            <img src={account} alt="img" />
          </div>
          <div className="contentUser">
            <h4 className="h4padding">
              {BundleOpportunityDetailsConstants.COMMISSION}
            </h4>
            <p className={`para0`}>{opportunityDetails?.brokerCommission}</p>
          </div>
        </div>

        <div className="customerDetails">
          <div className="imgIcon">
            <img src={account} alt="img" />
          </div>
          <div className="contentUser">
            <h4 className="h4padding">
              {BundleOpportunityDetailsConstants.BROKER}
            </h4>
            <p className={`para0`}>{opportunityDetails?.brokerName}</p>
          </div>
        </div>
      </Box>
    </BundleOpportuntiyDetailsWrapper>
  );
};

export default BundleOpportunityDetails;
